import React, { useState, useEffect } from "react";

import { Dialog, Card } from "@mui/material";
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from "../Buttons/Button";
import { useIsMobile } from "../../helpers/customHooks";
import { copyToClipboard } from "../../helpers/helperFunctions";

const ApiAccessModal = ({show, data, type, onClose, onSave}) => {
	const MOBILE = useIsMobile();
	const { t } = useTranslation();
	const [hidden, setHidden] = useState(true)
	// const handleChange = (type, e) => {
	// 	switch (type) {
	// 		case "email":
	// 			setEmail(e.target.value);
	// 			break;
	// 		case "vatnr":
	// 			setVatnr(e.target.value);
	// 			break;
	// 		default:
	// 			return;
	// 	}
	// 	setErrorText("");
	// };

	const handleSave = (type) => {
		let data = {};
		switch (type) {
			case "email":
			//	data = { email: email };
				break;
			default:
				data = {};
		}
		onSave(data);
	};

	const refreshToken = () => {
        const data = {action: "regenerate"}
		onSave(data)
	}

	const copyText = () => {
		copyToClipboard(data?.token)
	}

	const apiKeyContent = () => {
		return (
			<>
				<div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
					<div className="d-flex align-items-center">
						<img src={icons.gear_code} alt="" />
						<h3 className="ms-2">{t("settings.api_key")}</h3>
					</div>
					<img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." />
				</div>
				<div className="p-3">
					<p className="thin dark-grey text-center pb-3">{t("settings.api_key_desc")}</p>
					<form>
						<div className="form-group d-flex align-items-center position-relative">
							<input
								type={hidden ? "password" : "text"}
								className="form-control bg-light-grey p-2 pe-5"
								id="password"
								value={data.token ?? ""}
								placeholder=""
								readOnly={true}
							/>
							<img src={hidden ? icons.eye_slashed : icons.eye_open} onClick={() => setHidden(!hidden)} className="inp-link-icon position-absolute size_15 ms-2 cursor-pointer end-0 me-2" alt="" />
						</div>
					</form>
					<div className="d-flex mt-3 flex-row justify-content-between align-items-center">
						<Button icon={icons.refresh} onClick={() => refreshToken()} btnClass="btn-primary">
							{t("settings.refresh")}
						</Button>
						<Button icon={icons.copy} onClick={() => copyText()} btnClass="btn-primary">
							{t("settings.copy")}
						</Button>
					</div>
				</div>
				<div className="d-flex flex-row p-3 justify-content-end border-settings-top align-items-center">
					<Button onClick={() => onClose()} btnClass="btn-primary">
						{t("settings.close")}
					</Button>
				</div>
			</>
		);
	};


	const typeRender = () => {
		switch (type) {
			case "key":
				return apiKeyContent();
			case "documentation":
				return apiKeyContent();
			default:
				return null;
		}
	};

	return (
		<>
			<Dialog fullWidth={MOBILE ? true : false} open={show} onClose={() => onClose()}>
				<Card className="settings-dialog d-flex flex-column">
					<div className="w-100 h-100">{typeRender()}</div>
				</Card>
			</Dialog>
		</>
	);
};

export default ApiAccessModal;
